"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Select = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _fieldsize = require("../form/fieldsize");
var _icon = _interopRequireDefault(require("../icon"));
var _field = require("../form/field");
var _errorMessage = _interopRequireDefault(require("../form/error-message"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const SelectOptions = _ref => {
  let {
    role,
    open,
    options,
    cssClassNames,
    active,
    dataTestId,
    children,
    onClicks
  } = _ref;
  const refToFocus = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (open && refToFocus !== null && refToFocus !== void 0 && refToFocus.current) {
      refToFocus.current.focus();
    }
  }, [open]);
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.options, _indexModule.default.options, {
      [_indexModule.default.showing]: open
    }),
    role: role
  }, options.map((option, index) => /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.option, _indexModule.default.option, {
      [_indexModule.default.active]: active(option),
      [_indexModule.default.disabled]: option.disabled
    }),
    "data-test-id": dataTestId,
    key: "option-".concat(option.label ? (0, _field.makeIdFromName)(option.label) : index.toString())
  }, children({
    option,
    index,
    onClick: onClicks.option,
    refToFocus
  }))));
};
const Select = _ref2 => {
  let {
    open = false,
    placeholder = 'Choose an option',
    disabled,
    options,
    label,
    active,
    size = _fieldsize.FieldSize.DEFAULT,
    innerRef,
    onClicks,
    cssClassNames,
    children,
    dataTestId,
    buttonDataTestId,
    role = 'menu',
    errorMessage
  } = _ref2;
  const activeOption = options.find(active);
  const activeLabel = activeOption && label(activeOption) || placeholder;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.wrapper, _indexModule.default.group, {
      [_indexModule.default.disabled]: disabled
    })
  }, /*#__PURE__*/_react.default.createElement("button", {
    ref: innerRef,
    className: (0, _classnames.default)(cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.trigger, _indexModule.default.trigger, {
      [_indexModule.default.fieldInvalid]: errorMessage,
      [_indexModule.default.triggerSmall]: size === _fieldsize.FieldSize.SMALL,
      [_indexModule.default.triggerDefault]: size === _fieldsize.FieldSize.DEFAULT
    }),
    "data-test-id": buttonDataTestId
    // so we don't try to submit a form
    ,

    type: "button",
    onClick: onClicks.trigger
  }, activeLabel, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "chevron-".concat(open ? 'up' : 'down'),
    size: "small",
    className: _indexModule.default.icon
  })), /*#__PURE__*/_react.default.createElement(SelectOptions, {
    role: role,
    open: open,
    options: options,
    cssClassNames: cssClassNames,
    active: active,
    dataTestId: dataTestId,
    onClicks: onClicks
  }, children), errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
    message: errorMessage,
    className: cssClassNames === null || cssClassNames === void 0 ? void 0 : cssClassNames.errorMessage,
    size: size
  }));
};
exports.Select = Select;
Select.propTypes = {
  placeholder: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    disabled: _propTypes.default.bool
  })).isRequired,
  label: _propTypes.default.func.isRequired,
  active: _propTypes.default.func.isRequired,
  cssClassNames: _propTypes.default.shape({
    wrapper: _propTypes.default.string,
    trigger: _propTypes.default.string,
    option: _propTypes.default.string,
    options: _propTypes.default.string,
    errorMessage: _propTypes.default.string
  }),
  children: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  onClicks: _propTypes.default.shape({
    trigger: _propTypes.default.func.isRequired,
    option: _propTypes.default.func.isRequired
  }).isRequired,
  dataTestId: _propTypes.default.string,
  buttonDataTestId: _propTypes.default.string,
  role: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  size: _propTypes.default.any,
  errorMessage: _propTypes.default.string
};
var _default = exports.default = Select;